import antdFrFR from 'antd/es/locale/fr_FR';

const FrLang = {
  antd: antdFrFR,
  locale: 'fr-FR',
  messages: {
  },
};
export default FrLang;
